import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "../Common/PopupWrapper";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import VacationPrintPopup from "./VacationPrintPopup";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import {renderHTML} from "@mnjsplatform/data/lib/utils/htmlUtils";
import VacationForm from "./VacationForm";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";
import {loadBadges} from "../../actions/AppActions";

class VacationCreatePopup extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            printFormVisible: false,
            showMessage: false,
            messageText: '',
            showProgress: false,
            progressText: null,
            needCloseForm: false
        };
    }

    onPrint = () => {
        this.setState({printFormVisible: true});
    };

    onDelete = () => {
        this.props.onDelete(this.props.vacationKey);
    };

    onSendRequest = async () => {
        try {
            await this.props.dispatch(this.props.HRCPCar_HasFirmCarMsgForPO.execute());
            const message = '\n ' + this.props.HRCPCar_HasFirmCarMsgForPO.getField(0, 'MsgText');
            try {
                await confirm(renderHTML(`${i18next.t("SendRequest_Confirmation" + (this.props.isEdocPers ? "_EKDO" : ""))}${message}`),
                    {header: i18next.t("SendRequest" + (this.props.isEdocPers ? "_EKDO" : ""))});
                await this.props.dispatch(this.props.HolidayApp_CheckScanHolidayDoc.execute(this.props.vacationKey));
                const errMsg = this.props.HolidayApp_CheckScanHolidayDoc.getField(0, 'ErrMsg');
                if (errMsg) {
                    this.setState({
                        messageText: renderHTML(`${errMsg}<br><span class="text-danger">${i18next.t('Vacation_CheckRequest_Error')}</span>`),
                        showMessage: true
                    });
                } else {
                    if (this.props.isEdocPers) {
                        this.setState({
                            progressText: renderHTML(i18next.t(`Vacation_Request_Creating_Signing`)),
                            showProgress: true
                        });
                        await this.props.dispatch(this.props.HolidayApp_EDocSign.execute(this.props.vacationKey));
                    }
                    this.setState({
                        progressText: renderHTML(i18next.t(`Vacation_Request_Signed`)),
                        showProgress: true
                    });
                    if (!this.props.isEdocPers || !this.props.HolidayApp_EDocSign.isError) {
                        await this.props.dispatch(loadBadges());
                        this.setState({
                            progressText: renderHTML(i18next.t(`Vacation_SendRequest`)),
                            showProgress: true
                        });
                        await this.props.dispatch(this.props.HolidayApp_SendHolidayDoc.execute(this.props.vacationKey));
                        if (!this.props.HolidayApp_SendHolidayDoc.isError) {
                            this.setState({
                                messageText: renderHTML(i18next.t(`Vacation_Request_Sent`)),
                                showMessage: true,
                                showProgress: false,
                                needCloseForm: true
                            });
                            await this.refreshDataItem();
                        }
                    }
                }
            }
            catch (e) {
                
            }
        } finally {
            this.setState({
                showProgress: false
            });
        }
    }

    renderButtons = () => {
        //console.log(`this.props.row: ${JSON.stringify(this.props.row)}`);
        const sendAvailable = !this.props.readOnly && this.props.appItem.rowsCount() > 0 && this.props.row.IsSent !== 1;
        return (<div className="modal-footer text-right">
            {this.props.row.EDocIntId &&
                <button type="button"
                        className="btn btn-regular -goahead  ml1ex"
                        onClick={(event) => this.getDocument(this.props.row, event)}>{this.props.row.DoDownload}</button>
            }
            {this.props.isEdocPers &&
                <button type="button"
                        className="btn btn-regular -goahead  ml1ex"
                        onClick={this.onSendRequest}
                        disabled={!sendAvailable}>{i18next.t("SendRequest" + (this.props.isEdocPers ? "_EKDO" : ""))}</button>
            }
            {!this.props.isEdocPers &&
                <button type="button"
                        className="btn btn-regular -goahead  ml1ex"
                        onClick={this.onPrint}>{i18next.t("PrintStatement")}</button>
            }
            <button type="button"
                    className="btn btn-regular -goahead  ml1ex"
                    onClick={this.onDelete}
                    disabled={this.props.readOnly}>{i18next.t("RemoveStatement")}</button>
            <button type="button" className="btn btn-regular"
                    onClick={this.props.onClose}>{i18next.t("Close")}</button>
        </div>)
    }

    getDocument = async (row, event) => {
        event.preventDefault();
        const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "EDDocList", "DownloadDocument") + "?" + $.param({
            b_token: token,
            id: row.EDocIntId
        });
        window.open(downloadPath, '_blank');
    }

    refreshDataItem = async () => {
        await this.props.dispatch(this.props.appItem.refresh());
    }

    render() {
        return (<PopupWrapper popupVisible={true} title={i18next.t("VacationStatements", {title: this.props.title})}
                              staticTitle={i18next.t("VacationStatements")}
                              onClose={this.props.onClose} renderButtons={this.renderButtons}>

            {this.state.showProgress &&
                <PopupWrapper popupVisible={this.state.showProgress} title={i18next.t('Vacation_SendRequest')}
                              onClose={() => {
                                  this.setState({showProgress: false})
                              }}
                              renderButtons={() => {
                              }} maxWidthBody="300px" style={{marginTop: '200px'}}>
                    <div>{this.state.progressText}</div>
                </PopupWrapper>
            }
            <MessageBox visible={this.state.showMessage}
                        title={i18next.t('Status')}
                        messageText={this.state.messageText}
                        onClose={async() => {
                            this.setState({showMessage: false});
                            if(this.state.needCloseForm) {
                                await this.props.onClose(true);
                            }
                        }}
            />
            <PlaceholderWrapper placeholderId="31" title={i18next.t("VacationRequest_Creation")}
                                showHeaderTitle={false} canCollapse={false} showSplitterLine={false}>
                <GridView dataItem={this.props.appItem}
                          readOnly={this.props.readOnly}
                          addButtonText={i18next.t("AddVacation")}
                          afterEditRow={this.refreshDataItem}
                          afterDeleteRow={this.refreshDataItem}
                          renderAddForm={(props) => {
                              return <VacationForm addMode={true} {...props}/>;
                          }}
                          renderEditForm={(props) => {
                              return <VacationForm addMode={false} {...props}
                                                   rowKey={props.dataItem.getRowKey(props.row)}/>;
                          }}
                />

                {
                    this.state.printFormVisible &&
                    <VacationPrintPopup holidayList={this.props.appItem}
                                        vacationKey={this.props.vacationKey}
                                        onClose={() => {
                                            this.setState({printFormVisible: false})
                                        }}
                                        title={i18next.t("PrintVacationStatement")}
                    />
                }
            </PlaceholderWrapper>
        </PopupWrapper>)
    }
}

VacationCreatePopup.propTypes = {
    dispatch: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    onDelete: PropTypes.func,
    title: PropTypes.string,
    vacationKey: PropTypes.object,
    appItem: PropTypes.object,
    readOnly: PropTypes.bool,
    isEdocPers: PropTypes.bool,
    row: PropTypes.object
};


VacationCreatePopup.defaultProps = {
    readOnly: false
};

function mapStateToProps(state, ownProps) {
    return {
        HolidayApp_SendHolidayDoc: state.vacationState.HolidayApp_SendHolidayDoc,
        HolidayApp_CheckScanHolidayDoc: state.vacationState.HolidayApp_CheckScanHolidayDoc,
        HolidayApp_EDocSign: state.vacationState.HolidayApp_EDocSign,
        HRCPCar_HasFirmCarMsgForPO: state.vacationState.HRCPCar_HasFirmCarMsgForPO
    }
}

export default connect(mapStateToProps)(VacationCreatePopup)